module.exports = __webpack_public_path__ + "fe7f7212af99c12e34946699f430093f.pdf";